import { BoundingBox } from '../types'

export function geoToPixel(
  lat: number,
  long: number,
  boundingBox: BoundingBox,
  imageWidth: number,
  imageHeight: number
): { x: number; y: number } {
  const { north, south, east, west } = boundingBox

  // Normalize long/lat to 0–1 range
  const xPercent = (long - west) / (east - west)
  const yPercent = (north - lat) / (north - south)

  // Scale to image dimensions
  const x = xPercent * imageWidth
  const y = yPercent * imageHeight

  return { x, y }
}
